const namespace = {
  title: "Featured Neighborhoods",
  exploreMoreNeighborhoods: "EXPLORE MORE NEIGHBORHOODS",
  noData:
    "You haven't added any featured and favorite neighborhoods to your list yet. Head over to the <bold><LinkToHub>Featured Neighborhoods</LinkToHub></bold> section to select them.",
} as const;

export default namespace;
